
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

type Column = {
    key: string
    name: string

    align?: 'left' | 'center' | 'right'
}

export default defineComponent({
    props: {
        columns: {
            type: Array as PropType<Column[]>,
            default: () => []
        },
        rows: {
            type: Array as PropType<Record<string, any>>,
            default: () => []
        },
    }
})
